// 苏州园区 POC 自定义配置
export const SU_ZHOU_YUAN_QU = {
  appIds: ["5fe07364fb5cda7260eb1d14"] as string[],
  pwdLoginTabText: "原有方式登录",
  pwdLoginTabAlert: "您可以通过原有的统一政务平台的邮箱账号和密码登录",
};
